import { factsAreCompeting } from "./subject-intelligence.js";
export const SUBJECT_KNOWLEDGE_REVIEW_DECISIONS = [
    "add",
    "noop",
    "historical",
    "competing",
];
function asOfDay(asOf) {
    if (!asOf)
        return null;
    const match = asOf.match(/^(\d{4}-\d{2}-\d{2})/);
    return match?.[1] ?? null;
}
function unitOf(fact) {
    return fact.unit ?? "";
}
function noteOf(fact) {
    return fact.note ?? null;
}
export function factsHaveSameIdentity(a, b) {
    return (a.key === b.key &&
        a.value === b.value &&
        unitOf(a) === unitOf(b) &&
        asOfDay(a.asOf) === asOfDay(b.asOf) &&
        a.source === b.source &&
        noteOf(a) === noteOf(b));
}
function valueUnitOf(fact) {
    return `${fact.value}\0${unitOf(fact)}`;
}
/**
 * Live same-key classification for review apply. Uses 4B competing / 4D current-day
 * rules; does not change those functions.
 */
export function classifyCandidateFact(liveFacts, proposed) {
    const group = liveFacts.filter((row) => row.key === proposed.key && !row.superseded);
    if (group.some((row) => factsHaveSameIdentity(row, proposed)))
        return "noop";
    if (group.length === 0)
        return "add";
    const days = group.map((row) => asOfDay(row.asOf)).filter((day) => Boolean(day));
    const latestDay = days.sort().at(-1) ?? null;
    const proposedDay = asOfDay(proposed.asOf);
    const current = latestDay ? group.filter((row) => asOfDay(row.asOf) === latestDay) : group;
    if (!latestDay) {
        if (current.some((row) => factsAreCompeting(row, proposed)))
            return "competing";
        return "add";
    }
    if (proposedDay && proposedDay > latestDay)
        return "add";
    if (proposedDay && proposedDay < latestDay) {
        const differsValueUnit = current.some((row) => valueUnitOf(row) !== valueUnitOf(proposed));
        return differsValueUnit ? "historical" : "add";
    }
    if (current.some((row) => factsAreCompeting(row, proposed)))
        return "competing";
    return "add";
}
//# sourceMappingURL=subject-knowledge-review.js.map